import React from 'react';
import LinearLoader from '../../../cosmetics/linearLoader/LinearLoader';
import './PageContent.scss';
const PageContent = ({ children, className, loading }) => loading ? React.createElement(LinearLoader, null) : React.createElement("main", { className: `page-content ${className || ''}` }, children);
export default PageContent;
